import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getContact = createSelector(
    getModel,
    (model) => model.fetchContact,
);

export const getContactData = createSelector(
    getContact,
    (contact) => contact.data,
);

export const getIsFetchingContact = createSelector(
    getContact,
    (contact) => contact.isLoading,
);

export const getSelectedTab = createSelector(
    getModel,
    (model) => model.selectedTab,
);
